import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest, getRequestProductSales } from "shared/utils/fetch-api";
export const fetchDictionaries = createAsyncThunk(
    'contract/fetchDictionaries',
    async ({
        SellerId,
        Id,
        DefaultId
    }: {
        SellerId: string;
        Id: string;
        DefaultId: string;
    }, { rejectWithValue }) => {
        let requestBody = {}

        if (SellerId && !Id) {
            requestBody = { "sellerId": SellerId }
        } else if (Id && !SellerId) {
            requestBody = { "Id": Id }
        } else if (SellerId && Id) {
            requestBody = { "sellerId": SellerId }
        } else if (DefaultId) {
            requestBody = { "Id": DefaultId }
        } else {
            requestBody = {}
        }

        try {
            const response = await getRequest(requestBody, 'max-bot', 'getDictionaries', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    regions: data.Data.regions,
                    programs: data.Data.programs,
                    sellerId: data.Data.sellerId,
                    productId: data.Data.productId,
                    doNotShowRegion: data.Data.doNotShowRegion,
                };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return error.message;
        }
    }
);

export const fetchProductAlias = createAsyncThunk(
    'contract/fetchProductAlias',
    async ({
        agentSalesDataID,
    }: {
        agentSalesDataID: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            "AgentSalesDataID": agentSalesDataID,
            "Source": "Site",
        }
        try {
            const response = await getRequestProductSales(requestBody, 'product-sales', 'getProductAlias', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    ProductAlias: data.ProductAlias,
                    ProductPrintName: data.ProductPrintName,
                };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return error.message;
        }
    }
);
